import { Box, Flex, Grid, Heading } from '@chakra-ui/react';
import React from 'react';
import { Color } from 'src/theme/color';

export const FormSectionHeading = ({ children, label, description }: { children: React.ReactNode; label: string, description?: string  }) => {
	return (
		<Flex
			mb="50px"
			flexDirection="column"
		>
			<Box
				fontWeight="500"
				fontSize="14px"
				lineHeight="17px"
				color={Color.HASHUP}
			>
				{label}
			</Box>
			<Heading
				m="0"
				mt="10px"
				p="0"
				lineHeight="29px"
				fontSize="24px"
				color={'white'}
				fontWeight="bold"
			>
				{children}
			</Heading>
			<Box color="#686868" fontSize="14px" fontWeight="400" textAlign='left' pt='14px'>
				{description}
			</Box>
		</Flex>
	);
};
